// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
// import ArrowBackward, { ArrowBackwardOffset } from "@store/Library/Components/Toolkit/Icons/ArrowBackward"; // Store Custom Code
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import { menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { IconWrapper } from "@insite/mobius/Icon";
import ArrowBackward, { ArrowBackwardOffset } from "@store/Library/Components/Icons/ArrowBackward";
import CaretRight from "@store/Library/Components/Icons/CaretRight";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins/icon";
/* Store Custom Code - End */

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: menuPanelProps.wrapperCss,
            menu: menuPanelProps.menuCss,
        },
        closeButtonPanelRowProps: {
            css: menuPanelProps.headerCss,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: menuPanelProps.closeButtonIcon,
        parentPanelRowProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "inherit",
                    hoverColor: "inherit",
                    hoverUnderline: false,
                })}
                /* Store Custom Code - Start */
                ${IconWrapper} {
                    ${iconScalableStyles("1.7em", ArrowBackwardOffset)}
                }
                border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
                flex-wrap: wrap;
                &:active {
                    color: inherit;
                }
                /* Store Custom Code - End */
            `,
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "menu.mainNavigation.accent",
                    hoverColor: "menu.mainNavigation.accentHover",
                    borderColor: "transparent",
                })}

                width: auto;
                padding: 0;
                white-space: nowrap;
            `,
        },
        parentTypographyProps: {
            ellipsis: true,
            css: css`
                text-transform: uppercase;
            `,
        },
        backButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${menuPanelRowStyles({
                    borderColor: "transparent",
                    color: "menu.mainNavigation.accentContrast", // Store Custom Code
                    hoverColor: "menu.mainNavigation.accentHover",
                    iconOffset: ArrowBackwardOffset,
                })}
                display: flex;
                align-items: center;
                width: 100%;
                text-align: left;
                font-weight: ${x => x.theme.design.typography.weight.base}; /* Store Custom Code */
                /* Store Custom Code - Start */
                font-size: ${x => x.theme.design.typography.size.smaller};
                text-transform: initial;
                margin-top: -${pxToRem(20)};
                padding-top: 0;
                padding-left: 0;
                padding-right: 0;
                /* Store Custom Code - End */
            `,
        },
        backTitleTypographyProps: { ellipsis: true },
        backIconProps: { src: ArrowBackward }, // Store Custom Code
        bodyColor: "transparent",
        panelRowProps: {
            css: css`
                ${menuPanelRowStyles({ iconPosition: "right", borderColor: "transparent" })}
            `,
            isCurrentCss: css`
                background-color: transparent;
                /* Store Removed - text-decoration */
                color: ${getColor("menu.mainNavigation.accentHover")}; /* Store Custom Code */
            `,
            moreIconProps: { src: CaretRight, size: 26 }, // Store Custom Code
        },
        childTypographyProps: {
            size: "inherit",
            weight: "initial",
        },
    },
};

export default panelMenu;
